module.exports = "/dist/9e7beee5510fcd9cbc4dd37f2c721f14.woff2";


//////////////////
// WEBPACK FOOTER
// ./~/typeface-roboto/files/roboto-latin-500italic.woff2
// module id = 159
// module chunks = 0